module.exports = __webpack_public_path__ + "img/SMT_56_Ms_Selina_Toh_Sin_Yee.5f9f74b5.jpg";